import { applog } from "../../domain/utils/applog";
import { handleRemoteException } from "./handleRemoteException";

export const handleAxiosResult = async (promise: Promise<any>) => {
    let result;
    try {
        result = await promise;
        return result;
    } catch (error) {
        applog("handleAxiosResult ->","ERROR CATCHED", error);
        throw handleRemoteException(error);
    }
}
